'use client';

// base
import React, { useEffect, useRef, useState } from 'react';

// styles
import { StyledDatepicker } from './style';

// costants
import { commonImage } from 'constants/images';

// libraries
import { uniqueId } from 'lodash-es';
import DatePicker from 'react-datepicker';

type SingleDatepickerProps = {
  initialDate?: Date;
  fullWidth?: boolean;
  onChange: (date: Date | null) => void;
};

export const SingleDatepicker: React.FC<SingleDatepickerProps> = ({
  initialDate,
  fullWidth,
  onChange
}) => {
  const [selectedDate, setSelectedDate] = useState<Date | undefined>(undefined);

  const datepickerRef = useRef<DatePicker>(null);
  const datepickerIdRef = useRef(uniqueId('datepicker-'));

  const handleChange = (date: Date | null) => {
    setSelectedDate(date || undefined);
    if (date) onChange(new Date(date));
  };

  useEffect(() => {
    if (initialDate) setSelectedDate(initialDate);
  }, [initialDate]);

  return (
    <StyledDatepicker fullWidth={fullWidth}>
      <div className="datePickerWrapper">
        <DatePicker
          ref={datepickerRef}
          dateFormat="dd-MMM-yyyy"
          placeholderText="DD-MMM-YYYY"
          id={datepickerIdRef.current}
          selected={selectedDate}
          onChange={handleChange}
        />

        <label
          htmlFor={datepickerIdRef.current}
          onClick={() => datepickerRef.current?.setOpen(true)}
        >
          <img src={commonImage.calender} alt="" />
        </label>
      </div>
    </StyledDatepicker>
  );
};
